import {pageHeaderHeight, pageNavigationOpened, pageNavigationClosed} from '@pb/kit-stylus/config.json';


export const pageDimensions = {
    getHeaderHeight: () => {
        if (!document.querySelector('.page__header')) {
            return 0;
        }
        return pageHeaderHeight;
    },
    getFooterHeight: () => {
        const footer = document.querySelector('.page__footer');
        return !footer ? 0 : (footer as HTMLElement).offsetHeight;
    },
    getSidebarWidth: () => {
        if (!document.querySelector('.page')) {
            return 0;
        }
        return document.querySelector('.page_nav-closed') ? pageNavigationClosed : pageNavigationOpened;
    },
};
